module.exports = __webpack_public_path__ + "img/jiao.1c12ca2e.png";